// removed by extract-text-webpack-plugin
module.exports = {"container":"R5WNnzX8GujsVHVidIu9F","circle":"_1375_yHBE0x3ZLbKNqGoNX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Background/MovingBlobs.mod.css
// module id = 988
// module chunks = 0